import PropTypes from 'prop-types';
import React from 'react'

import { Row, Col, FormGroup, Switch, Label } from 'twyne-new.ui';


class ClickToCallQuestion extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      callquestion: null,
      customFields: null,
      customFieldSelected: null
    }
  }

  componentWillMount() {
    this.updateCustomFields(this.props);
  }

  componentWillReceiveProps(props) {
    this.updateCustomFields(props);
    this.updateOptions(this.state.customFieldSelected);
  }

  updateCustomFields = ({ integrationData: { extraFields, callquestion } }) => {

    const customFields = (extraFields || []).map(({
      id, group, type, options, key: value, name: label
    }) => ({
      id, group, type, options, value, label: `${label} (${type})`
    }));
    const customFieldSelected = customFields.find(field => callquestion.cfid === field.value) || {};
    callquestion.cfid_number = callquestion.cfid_number || customFieldSelected.id;

    this.state = {
      callquestion,
      customFields,
      customFieldSelected
    };

  }
  makeDefaultAnswer = (answer) => {
    return Object.assign({
      key: "",
      answer: "",
      fontcolor: "255,255,255,1",
      color: "113,113,113,1"
    }, answer);
  }

  addPostData = (answers, answer) => {
    answers.push(this.makeDefaultAnswer(answer));
    return answers
  }

  updateOptions = (cf) => {
    const { callquestion } = this.state
    if (!cf) return;
    let isSelect = cf.type === 'select',
      isBoolean = cf.type === 'boolean';

    if (isBoolean || isSelect) {
      if (isSelect) {
        let answers = callquestion.answers;
        let currentKeyAnswers = answers.map(({ key }) => key);
        let newKeysAnswers = cf.options.map(({ value: key }) => key);
        answers.forEach((answer, idx) => {
          !newKeysAnswers.includes(answer.key) && this.handleClickRemovePostData(idx);
        });
        cf.options.forEach(({ value: key, label: answer }) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData({ key, answer });
        });
      }
      if (isBoolean) {
        let answers = callquestion.answers;
        let options = [{ key: "true", answer: "Yes" }, { key: "false", answer: "No" }];
        let currentKeyAnswers = answers.map(({ key }) => key);
        answers.forEach(({ key }, idx) => {
          !["true", "false"].includes(key) && this.handleClickRemovePostData(idx)
        });
        options.forEach(({ key, answer }, idx) => {
          !currentKeyAnswers.includes(key) && this.handleClickAddPostData(this.makeDefaultAnswer({ key, answer }))
        });
        return;
      }
      return;
    }
    callquestion.answers = callquestion.answers || [];
  }

  handleClickRemovePostData = (idx) => {
    const answers = this.state.callquestion.answers
    answers.splice(idx, 1);
    this.props.onChange('answers', answers)
  }

  handleClickAddPostData = (answer) => {
    this.props.onChange('answers', this.addPostData(this.state.callquestion.answers, answer))
  }

  handleEnableTrustedForm = (e) => {
    let checked = e.target.checked

    if (checked) {
      if (this.state.callquestion.cfid === null || this.state.callquestion.cfid === undefined) return
      this.props.onChange('trustedform', checked)
      this.props.onChange('trustedform_cfid', `${this.state.callquestion.cfid}_trustedform`)
    } else {
      this.props.onChange('trustedform', false)
      this.props.onChange('trustedform_cfid', '')
    }

  }

  handleEnableLeadId = (e) => {
    let checked = e.target.checked

    if (checked) {
      if (this.state.callquestion.cfid === null || this.state.callquestion.cfid === undefined) return
      this.props.onChange('leadid', checked)
      this.props.onChange('leadid_cfid', `${this.state.callquestion.cfid}_leadid`)
    } else {
      this.props.onChange('leadid', false)
      this.props.onChange('leadid_cfid', '')
    }

  }
  handleEnable = field => ({ target: { checked } }) => {
    this.props.onChange(field, checked)
  }


  render() {
    return (
      <div key={this.state.callquestion.cfid || ''}>
        <Row className='mt-4'>
          {this.props.settings}
          <Col size='2'>
            <FormGroup>
              <Label>Trusted Form?</Label>
              <Switch
                onChange={e => this.handleEnableTrustedForm(e)}
                checked={this.state.callquestion.trustedform || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>LeadId?</Label>
              <Switch
                onChange={e => this.handleEnableLeadId(e)}
                checked={this.state.callquestion.leadid || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Always Visible?</Label>
              <Switch
                onChange={this.handleEnable('alwaysShow')}
                checked={this.state.callquestion.alwaysShow || false}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Auto Scroll to Consent</Label>
              <Switch
                onChange={this.handleEnable('autoScrollToConsent')}
                checked={this.state.callquestion.autoScrollToConsent || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

ClickToCallQuestion.propTypes = {
  data: PropTypes.any,
  integrationData: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onCustomFieldClick: PropTypes.func
}

export default ClickToCallQuestion
